import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'material-ui-pickers/DatePicker';
import FormControl from '@material-ui/core/FormControl';
import IconArrowDropDown from '@material-ui/icons/ArrowDropDown';
import formatDate from '../../helper/formatDate';

const RateDate = (props) => {
  const value = formatDate(props.value);

  return (
    <FormControl fullWidth>
      <DatePicker
        disableFuture
        label="Kursdatum"
        format="DD.MM.YYYY"
        mask={input => (input ? [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/] : [])}

        leftArrowIcon="&laquo;"
        rightArrowIcon="&raquo;"
        value={value}
        onChange={props.onChange}
        showTodayButton
        todayLabel="Heute"
        cancelLabel="Abbrechen"
        disableOpenOnEnter
        autoOk
        keyboard
        keyboardIcon={(<IconArrowDropDown />)}
        invalidDateMessage="Das Format ist nicht korrekt."
        maxDateMessage="Das Datum kann nicht in der Zukunft liegen."
        minDateMessage="Das Datum muss nach dem Jahr 1999 liegen."

        InputLabelProps={{
          style: {
            fontSize: '22px',
            lineHeight: '18px',
            marginBottom: '0rem',
            position: 'relative',
          },
        }}
      />

    </FormControl>
  );
};
export default RateDate;

RateDate.propTypes = {
  value: PropTypes.instanceOf(Date).isRequired,
  onChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/calculator/RateDate.js